class BundleConfigurator extends HTMLElement {
  constructor() {
    super();
    this.selectedVariants = {};
    this.bundleName = this.dataset.bundleName;
    this.addToCartButton = this.querySelector('[js-add-to-cart]');
    this.totalRows = this.querySelectorAll('[js-bundle-row]').length;
  }

  connectedCallback() {
    this.initSelections();
    this.updateTotalPrice();
    this.attachEventListeners();
    this.setupGalleryDots();    
    this.updateAddToCartState();
  }

  initSelections() {
    this.querySelectorAll(['[js-bundle-row]']).forEach(bundleProduct => {
      const productId = bundleProduct.dataset.productId;
      let firstAvailableSize = bundleProduct.querySelector('.bundle__product__wrapper.is-active .variant-btn:not(.is-disabled)');
      if (!firstAvailableSize) {
        firstAvailableSize = bundleProduct.querySelector('.bundle__product__wrapper.is-active .variant-btn');
      }
      this.selectVariant(productId, firstAvailableSize);
    });
  }

  attachEventListeners() {
    this.querySelectorAll('.variant-btn').forEach(button => {
      button.addEventListener('click', event => {
        const productId = event.target.closest(['[js-bundle-row]']).dataset.productId;
        this.selectVariant(productId, event.target);
      });
    });
    
    this.querySelectorAll('.meta-pro').forEach(swatch => {
      swatch.addEventListener('click', event => {
        this.selectColor(event.target.closest('.meta-pro'));
      });
    });

    this.addToCartButton.addEventListener('click', () => this.addToCart());
  }

  setupGalleryDots() {
    document.querySelectorAll('.bundle__gallery__single__dot').forEach(dot => {
      dot.addEventListener('click', (event) => {
        const imageId = event.target.dataset.imageId
        const dotId = event.target.dataset.dotId
        const gallery = dot.closest('.bundle__gallery__single')
        const targetImage = gallery.querySelector(`[data-target='${imageId}__${dotId}']`)
        const slider = gallery.querySelector(`.bundle__gallery__slider[data-target='${imageId}']`)
      
        if (targetImage && slider) {
          const scrollTo = targetImage.offsetLeft
          slider.scrollTo({
            left: scrollTo,
            behavior: 'smooth'
          })
        }
      })
    });

    document.querySelectorAll('.bundle__gallery__slider').forEach(wrapper => {
      wrapper.addEventListener('scroll', () => {
        this.updateActiveDots(wrapper);
      });
    });
  }
  updateActiveDots(wrapper) {
    const dotsContainer = wrapper.closest('[js-slider-wrapper]').querySelector('.bundle__gallery__dots');
    const images = [...wrapper.querySelectorAll('.bundle__gallery__single__image')];
    const dots = [...dotsContainer.querySelectorAll('.bundle__gallery__single__dot')];
  
    const scrollLeft = wrapper.scrollLeft
    const wrapperWidth = wrapper.offsetWidth
  
    let activeIndex = 0
    let minDistance = Infinity
  
    images.forEach((image, index) => {
      const offset = image.offsetLeft
      const distance = Math.abs(offset - scrollLeft)
  
      if (distance < minDistance) {
        minDistance = distance
        activeIndex = index
      }
    })
  
    dots.forEach(dot => dot.classList.remove('is-active'))
  
    let targetDot = dots[activeIndex]
    if (!targetDot || targetDot.offsetParent === null) {
      for (let i = activeIndex - 1; i >= 0; i--) {
        if (dots[i] && dots[i].offsetParent !== null) {
          targetDot = dots[i]
          break
        }
      }
    }
  
    targetDot?.classList.add('is-active')
  }

  selectColor(swatch) {
    const parent = swatch.closest(['[js-bundle-row]']);
    const color = swatch.dataset.color;
    const url = swatch.dataset.url;
    const colorLabel = swatch.dataset.colorLabel;
    const previousSize = this.selectedVariants[parent.dataset.productId]?.size;
    const row = swatch.dataset.row
    
    parent.querySelectorAll('.meta-pro').forEach(swatch => swatch.classList.remove('active'));
    swatch.classList.add('active');
    
    parent.querySelectorAll('.bundle__product__wrapper').forEach(wrapper => {
      wrapper.classList.remove('is-active');
    });

    parent.querySelectorAll('[js-current-color-name]').forEach(span => {
      span.textContent = colorLabel;
    });

    parent.querySelectorAll('[js-current-product]').forEach(anchor => {
      anchor.textContent = `${colorLabel} Details`;
      anchor.setAttribute('href', url);
    });

    this.updateDesktopSlider(row, color);
    
    const activeWrapper = parent.querySelector(`.bundle__product__wrapper[data-color='${color}']`);
    if (activeWrapper) {
      activeWrapper.classList.add('is-active');
      
      if (previousSize) {
        let newSizeButton = activeWrapper.querySelector(`.variant-btn[data-size='${previousSize}']:not(.is-disabled)`);
        if (!newSizeButton) {
          newSizeButton = activeWrapper.querySelector(`.variant-btn[data-size='${previousSize}']`);
        }
        if (newSizeButton) {
          this.selectVariant(parent.dataset.productId, newSizeButton);
          return;
        }
      }
      
      let firstAvailableSize = activeWrapper.querySelector('.variant-btn:not(.is-disabled)');
      if (!firstAvailableSize)  {
        firstAvailableSize = activeWrapper.querySelector('.variant-btn');
      }
      this.selectVariant(parent.dataset.productId, firstAvailableSize);
      this.updateAddToCartState();
    }
  }

  updateDesktopSlider(row, color) {
    document.querySelectorAll(`.bundle__gallery__single__wrapper[data-row="${row}"]`)
      .forEach(wrapper => {
        wrapper.classList.remove('is-active');
      });
      

    document.querySelectorAll(`.bundle__gallery__single__wrapper[data-row="${row}"][data-color="${color}"]`)
      .forEach(wrapper => {
        wrapper.classList.add('is-active');
      });
  }

  selectVariant(productId, button) {
    if (button) {
      const parent = button.closest(['[js-bundle-row]']);
      // const bundleProduct = button.closest(['[js-bundle-row]']);
      const variantButtons = parent.querySelectorAll('.variant-btn');

      parent.querySelectorAll('[js-current-size-name]').forEach(span => {
        span.textContent = button.dataset.size;
      });
      

      variantButtons.forEach(btn => {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-checked', 'false');
      });

      button.classList.add('is-active');
      button.setAttribute('aria-checked', 'true');

      this.selectedVariants[productId] = {
        id: button.dataset.id,
        price: parseFloat(button.dataset.price),
        available: button.dataset.available === 'true',
        size: button.dataset.size,
      };

      const row = button.dataset.row
      const size = button.dataset.handleSize
      this.updateGalleryVisibility(row, size, parent)
      this.updateTotalPrice();
    } else {
      this.selectedVariants[productId] = {
        id: null,
        price: 0,
        size: null,
        available: false
      };
    }
    
    this.updateAddToCartState();
  }

  updateTotalPrice() {
    let totalPrice = Object.values(this.selectedVariants).reduce((sum, variant) => sum + (variant.price || 0), 0);
    document.querySelectorAll('[data-bundle-price]').forEach(el => {
      el.textContent = `$${(totalPrice / 100 * 0.9).toFixed(2)}`;
    });
    document.querySelectorAll('[data-bundle-compare-price]').forEach(el => {
      el.textContent = `$${(totalPrice / 100).toFixed(2)}`;
    });
  }

  updateAddToCartState() {
    const allAvailable = Object.values(this.selectedVariants).every(variant => variant.available);
    const addToCartText = this.addToCartButton.querySelector('[data-add-to-cart-text]');

    if (allAvailable && Object.values(this.selectedVariants).length === this.totalRows) {
      this.addToCartButton.classList.remove('is-disabled');
      this.addToCartButton.removeAttribute('disabled');
      addToCartText.textContent = 'Add to cart';
    } else {
      this.addToCartButton.classList.add('is-disabled');
      this.addToCartButton.setAttribute('disabled', 'true');
      addToCartText.textContent = 'Sold Out';
    }
  }

  updateGalleryVisibility(row, selectedSize, parent) {
    const sliders = document.querySelectorAll(`.bundle__gallery__single__wrapper[data-row='${row}'] .bundle__gallery__slider`) || []
    const mobileSliders = parent.querySelectorAll(`.bundle__product[data-row='${row}'] .bundle__gallery__slider`) || []

    const allSliders = [...sliders, ...mobileSliders]
    if (allSliders.length == 0) return

    allSliders.forEach(slider => {
      const images = slider.querySelectorAll('.bundle__gallery__single__image')
      let hasFilteredImages = false

      images.forEach(img => {
        const imgSize = img.dataset.size
        if (!imgSize || imgSize === selectedSize) {
          img.classList.add('is-visible')
          img.classList.remove('is-hidden')
          hasFilteredImages = true
        } else {
          img.classList.remove('is-visible')
          img.classList.add('is-hidden')
        }
      })

      if (hasFilteredImages) {
        slider.classList.add('is-filtered')
      } else {
        slider.classList.remove('is-filtered')
      }
    })
  }
  

  addToCart() {
    if (this.addToCartButton.classList.contains('is-loading')) {
      return;
    }

    const allAvailable = Object.values(this.selectedVariants).every(variant => variant.available);
    if (allAvailable && theme && theme.cart) {
      const cartItems = [];
      this.addToCartButton.classList.add('is-loading');

      Object.values(this.selectedVariants).forEach(variant => {
        cartItems.push({
          id: variant.id,
          quantity: 1,
          properties: {
            _pdp_bundle: this.bundleName
          }
        });
        // let existingItem = cartItems.find(item => item.id === variant.id);
        // if (existingItem) {
        //   existingItem.quantity += 1;
        // } else {
          
        // }
      });
  
      const formData = new URLSearchParams();
      cartItems.forEach((item, index) => {
        formData.append('items[][id]', item.id);
        formData.append('items[][quantity]', item.quantity);
        formData.append('items[][properties][_pdp_bundle]', item.properties._pdp_bundle);
        formData.append('items[][properties][Bundle Product]', index + 1);
        const randomNumber = Math.floor(Math.random() * 9999);
        formData.append('items[][properties][_pdp_bundle_row]', `${index}-${randomNumber}`);
      });

      const result = window.theme.cart.addItemsFromForm(formData.toString());

      if (result && typeof result.then === 'function') {
        result
          .then(() => {
            document.dispatchEvent(new CustomEvent('added:ajaxProduct'));
            this.addToCartButton.classList.remove('is-loading');
          })
          .catch(error => {
            console.error('Error adding bundle to cart:', error);
            this.addToCartButton.classList.remove('is-loading');
          });
      } else {
        document.dispatchEvent(new CustomEvent('added:ajaxProduct'));
        this.addToCartButton.classList.remove('is-loading');
      }
    }
  }

  disconnectedCallback() {
    this.querySelectorAll('.variant-btn').forEach(button => {
      button.removeEventListener('click', this.boundSelectVariant);
    });
    
    this.querySelectorAll('.meta-pro').forEach(swatch => {
      swatch.removeEventListener('click', this.boundSelectColor);
    });

    this.addToCartButton.removeEventListener('click', this.boundAddToCart);
  }
}

customElements.define('bundle-configurator', BundleConfigurator);
